import Vue from 'vue';
import Component from 'vue-class-component';
import front from '@/../static/js/proto/CtpFront';
import * as ConditionData from '../../ConditionData';
import * as format from '@/utils/format';
import * as utils from '@/utils/utils';
import _ from 'lodash';
/**
 * 未触发条件单
 */
@Component({
})
export default class ConditionTriggered extends Vue {

  public conditionTriggeredList: IOrderConditional[] = [];
  public formFind = {
    start: (new Date()),
    end: (new Date()),
  };
  public selectedState = front.con_order_trigger;

  public tabState = {
    已触发: front.con_order_trigger,
    已删除: front.con_order_delete,
    已结算: front.con_order_settlement,
  };
  public tableData: any[] = [];

  public get findStart() {
    return format.formatDate(this.formFind.start);
  }
  public get findEnd() {
    return format.formatDate(this.formFind.end);
  }

  public tableTitle: IFixedTableTitle[] = [
    {
      text: '合约',
      width: '2rem',
      name: 'contract',
    },
    {
      text: '触发时间',
      width: '3.5rem',
      name: 'triggerTime',
    },
    {
      text: '状态',
      width: '1.5rem',
      name: 'state',
    },
    {
      text: '条件',
      width: '1.5rem',
      name: 'condition',
    },
    {
      text: '下单',
      width: '3rem',
      name: 'order',
    },
    {
      text: 'ID',
      width: '6rem',
      name: 'id',
    }];
  public sheetVisible: boolean = false;
  public typeData: string = '全部';
  public filtFlage: boolean = true;
  public orderType: number = 0;
  public actionData: any[] = [
    {
      name: '全部',
      font: '&#xe623;',
      font02: '&#xe626;',
    }, {
      name: '云条件单',
      font: '&#xe623;',
      font02: '&#xe626;',
    }, {
      name: '止盈止损单',
      font: '&#xe623;',
      font02: '&#xe626;',
    }];
  public selectIndex: string = '0';
  // public get tableData() {
  //   const arr: any[] = [];
  //   for (const item of this.conditionTriggeredList) {
  //     console.log(item);
  //     if ((item as any).orderType === 0) {
  //       if (item.state === this.selectedState) {
  //         arr.push({
  //           contract: item.targetId,
  //           state: ConditionData.
  //             getText(ConditionData.con_active_state, item.state),
  //           condition: ConditionData.getCondition(item),
  //           order: ConditionData.getOrder(item),
  //           id: item.id,
  //           triggerTime: (item.triggerDate + '').
  //             replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + ' '
  //             + (item.triggerTime + '').replace(/\..*/, ''),
  //         });
  //       }
  //     }
  //   }
  //   return _.orderBy(arr, ['triggerTime'], ['desc']);
  // }

  public deactivated() {
    this.conditionTriggeredList = [];
    this.tableData = [];
    utils.closeIndicator();
  }
  public mounted() {
    this.queryData();
  }
  public activated() {
    this.queryData();
  }
  public queryData() {
    this.tableData = [];
    console.log('query', this.findStart, this.findEnd);
    return new Promise((resolve, reject) => {
      // utils.clearArr(this.conditionTriggeredList);
      front.conditionOrderQry('', '',
        this.findStart.replace(/[\-]/g, ''),
        this.findEnd.replace(/[\-]/g, ''),
        data => {
          let conditionData: any = '';
          if ((data as any).orderType === 0) {
            conditionData = ConditionData.getCondition(data);
          } else {
            if (data.direction === 1) {
              conditionData = ConditionData.getCondition(data);
            } else {
              conditionData = ConditionData.getConditions(data);
            }
          }
          // const conditionData = (data as any).orderType === 0 ? ConditionData.getCondition(data) : ConditionData.getConditions(data);
          console.log('triggered', data, data.state);
          if (this.filtFlage) {
            this.tableData.push({
              contract: data.targetId,
              state: ConditionData.
                getText(ConditionData.con_active_state(), data.state),
              condition: conditionData,
              order: ConditionData.getOrder(data),
              id: data.id,
              triggerTime: (data.updateDate + '').
                replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + ' '
                + (data.updateTime + '').replace(/\..*/, ''),
            });
          } else {
            if ((data as any).orderType === this.orderType) {
              this.tableData.push({
                contract: data.targetId,
                state: ConditionData.
                  getText(ConditionData.con_active_state(), data.state),
                condition: conditionData,
                order: ConditionData.getOrder(data),
                id: data.id,
                triggerTime: (data.updateDate + '').
                  replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + ' '
                  + (data.updateTime + '').replace(/\..*/, ''),
              });
            }
          }
          this.tableData.sort(function (a, b) {
            return b.triggerTime > a.triggerTime ? 1 : -1;
          });
          resolve();
        }, err => {
          if (err.message === '查询返回为空. ecmsg:成功') {
            utils.toast('查询列表为空');
          } else {
            utils.toast('错误:' + err.message);
          }
          // console.log(err);
          reject();
        });
    });
  }
  public handleQuery() {
    utils.indicator('正在查询');
    this.queryData()
      .then(() => utils.closeIndicator())
      .catch(() => utils.closeIndicator());
  }
  // 选取条件单类型
  public handleSelectType(index) {
    this.selectIndex = index;
    if (index === 0) {
      this.filtFlage = true;
    } else if (index === 1) {
      this.filtFlage = false;
      this.orderType = 0;
    } else if (index === 2) {
      this.filtFlage = false;
      this.orderType = 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/ConditionTriggered/ConditionTriggered.ts